export const onboardA2ADialogIndexEnums = Object.freeze({
  ERROR: 'ERROR',
  LOADING: 'LOADING',
  OPENING: 'OPENING',
  SELECT_INST: 'SELECT_INST',
  SELECT_ACCT: 'SELECT_ACCT',
  ACCT_INFO: 'ACCT_INFO',
  SUBMIT: 'SUBMIT',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  READY_TO_TRANSFER: 'READY_TO_TRANSFER',
});

export type onboardA2ADialogIndex =
  | 'ERROR'
  | 'LOADING'
  | 'OPENING'
  | 'SELECT_INST'
  | 'SELECT_ACCT'
  | 'ACCT_INFO'
  | 'SUBMIT'
  | 'SUCCESS'
  | 'FAILURE'
  | 'READY_TO_TRANSFER';
